import { ConsortiumSearchSelect } from '@/components/form-fields';

export const getFormFields = () => {
  return [
    {
      name: 'name',
      permissionName: 'cooperative.name',
      componentName: 'input',
      params: {
        i18nLabel: 'counterparties.name',
      },
      rules: [{ required: true }],
    },
    {
      name: 'code',
      permissionName: 'cooperative.code',
      componentName: 'input',
      params: {
        i18nLabel: 'counterparties.code',
      },
      // Now required everywhere: the column is NOT NULL at the DB level
      // (1779285635830 migration) and is the canonical identifier across
      // all ingest paths. Existing rows missing a code were backfilled as
      // `LEGACY-{id}` so the operator can spot them and replace.
      rules: [{ required: true, max: 50 }],
    },
    {
      name: 'consortiumIds',
      permissionName: 'cooperative_consortium_detail',
      componentName: 'dropdown',
      component: ConsortiumSearchSelect,
      params: {
        i18nLabel: 'counterparties.consortium',
        allowClear: true,
        mode: 'multiple',
      },
    },
    {
      name: 'isEudrCompliant',
      permissionName: 'cooperative.isEudrCompliant',
      componentName: 'checkbox',
      params: {
        i18nLabel: 'cooperative.isEudrCompliant',
      },
    },
  ];
};
